import { render, staticRenderFns } from "./TheBottomNav.vue?vue&type=template&id=8aac8756&scoped=true&"
import script from "./TheBottomNav.vue?vue&type=script&lang=js&"
export * from "./TheBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./TheBottomNav.vue?vue&type=style&index=0&id=8aac8756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aac8756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBottomNavigation,VBtn,VIcon})
